import {
  ADDITIONAL_CLIENT_HEADERS,
  API_URL,
} from '@diamond/shared/environments';
import { jwtPayload } from '@diamond/shared/utils';
import { GetServerSideProps } from 'next';

export const getAuthStateFromServer: GetServerSideProps = async (context) => {
  const token = context.req.cookies['buyer_jwt_token'];

  if (!token) {
    return {
      props: {
        isAuthenticated: false,
      },
    };
  }

  const payload = jwtPayload(token);

  const data = await fetch(`${API_URL}/user/buyer/${payload.id}`, {
    cache: 'no-store',
    headers: {
      Authorization: `Bearer ${token}`,
      ...ADDITIONAL_CLIENT_HEADERS,
    },
  });

  if (!data.ok && data.status === 401) {
    return {
      props: {
        isAuthenticated: false,
      },
    };
  }

  return {
    props: {
      isAuthenticated: true,
    },
  };
};
